class PopupClose {
	constructor(button) {
		this.button = button;
		this.onClick = this.onClick.bind(this);
	}

	static init() {
		const closeButtons = document.querySelectorAll('.popup-close-icon, #popup-close-icon');
		if (!closeButtons.length) return;

		closeButtons.forEach((button) => {
			new PopupClose(button).attach();
		});
	}

	attach() {
		this.button.addEventListener('click', this.onClick);
	}

	onClick() {
		const popup = this.button.closest('.levit-popup-container');
		if (!popup) return;

		popup.classList.remove('toggled');
	}
}

export default PopupClose;
